import { render, staticRenderFns } from "./NachhaltigkeitMenuIcon.vue?vue&type=template&id=47f2a953&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports